jQuery(($) => {
    const $body = $('body');

    $(window).scroll(() => {
        const $adminBar = $('#wpadminbar')
        const $bannerWrapper = $('.banner_wrapper')

        const isMobile = $(window).width() < 768;
        const offset = $bannerWrapper.height() + (isMobile && $adminBar.length > 0 ? $adminBar.height() : 0);
        const windowPos = $(window).scrollTop();

        if (windowPos >= offset) {
            $body.addClass('scrolled');
        } else {
            $body.removeClass('scrolled');
        }
    });

    const $pisolBadge = $('#pisol-ppscw-badge span')

    function loadLocation() {
        if (typeof pi_ppscw_setting === 'undefined') return;
        const action = 'pi_load_location_by_ajax';
        const request = $.ajax({
            type: 'POST',
            url: pi_ppscw_setting.wc_ajax_url.toString().replace('%%endpoint%%', action),
            data: {
                action: action
            },
            dataType: "json",
        });
        request.done(function (res) {
            $(document).trigger('pi_location_by_ajax_loaded', [res]);
            if (res.calc_shipping_postcode) {
                $pisolBadge.addClass('loaded')
                $pisolBadge.html('<span class="postal-code-label">CP Envío</span>' + res.calc_shipping_postcode)
            }
        })
    }

    $(document).on('pisol_shipping_address_updated', () => {
        loadLocation();
    })

    $(document).on('pi_location_by_ajax_loaded', (event, data) => {
        if (data.calc_shipping_postcode) {
            hideTooltip()
        } else {
            showTooltip()
        }
    });

    $('#pisol-ppscw-badge-container').click(() => {
        hideTooltip()
    })

    $('.pick-shipping-tooltip .close-btn').click(() => {
        hideTooltip()
        saveHideTooltipPreference()
    })

    function showTooltip() {
        if (canShowTooltip()) {
            $body.addClass('show-location-tooltip')
        }
    }

    function hideTooltip() {
        $body.removeClass('show-location-tooltip')
    }

    function canShowTooltip() {
        return localStorage.getItem('pisol_tooltip') !== 'hide'
    }

    function saveHideTooltipPreference() {
        localStorage.setItem('pisol_tooltip', 'hide')
    }

    $('.product-search-field').focus(() => {
        hideTooltip()
    })

    loadLocation();
});
